function NavLabel({ children, navFunction }) {
  return (
    <label className="navLabel" onClick={() => navFunction()}>{children}</label>
  )
}

export default NavLabel